import {
  RegisterEmployeeMutation,
  RegisterEmployeeMutationVariables,
  useRegisterEmployeeMutation,
} from '@alice-financial/alice-sdk'
import { UseGqlMutationCallbacks, useMutationOptionsWithInvalidation } from '@alice-financial/api'

export type UseRegisterEmployeeOptions = UseGqlMutationCallbacks<
  RegisterEmployeeMutation,
  RegisterEmployeeMutationVariables
>
export const useRegisterEmployee = (mutationOptions?: UseRegisterEmployeeOptions) =>
  useRegisterEmployeeMutation(useMutationOptionsWithInvalidation(mutationOptions, 'all'))
